import Loader from "react-loaders";
import "./index.scss";
import img1 from "../../assets/images/krisplogo.png";
import img2 from "../../assets/images/osnlogo.png";
import img3 from "../../assets/images/Hardees-Logo.png";
import img4 from "../../assets/images/ndblogo.png";
import img5 from "../../assets/images/dinalogo.png";
import img6 from "../../assets/images/xceed.png";
import img7 from "../../assets/images/ithadlogo.png";
import img8 from "../../assets/images/onvologo.png";
import img9 from "../../assets/images/adclogo.png";
import img10 from "../../assets/images/ITS-logo.png";
import img11 from "../../assets/images/shecanlogo.png";

const Clients = () => {
  return (
    <>
      <div className="services-title">
        <h1>Our Clients</h1>
      </div>
      <div className="clients-content">
        <div className="logo-grid">
          {/* Repeat for each client logo */}
          <div className="logo-item">
            <img src={img1} alt="krisplogo" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img2} alt="osn" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img3} alt="hardees" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img4} alt="NBD" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img5} alt="Dina Farmes" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img6} alt="xceed" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img7} alt="ithad" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img8} alt="onvo" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img9} alt="adc" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img10} alt="its" className="client-logo" />
          </div>
          <div className="logo-item">
            <img src={img11} alt="its" className="client-logo" />
          </div>
          {/* Add more logos as needed */}
        </div>
      </div>
    </>
  );
};

export default Clients;
